import { Pager as HeadlessPager } from '@coveo/headless';
import classNames from 'classnames';
import { FunctionComponent, useEffect, useState } from 'react';
import SvgIcon from 'src/helpers/SvgIcon/SvgIcon';
import { useCurrentVideoStore } from 'src/helpers/VideoGalleryHelpers/VideoListing.store';
import { twMerge } from 'tailwind-merge';

interface PagerProps {
  controller: HeadlessPager;
  pagerClasses?: {
    [property: string]: string;
  };
}

export const Pager: FunctionComponent<PagerProps> = (props) => {
  const { controller, pagerClasses } = props;
  const [state, setState] = useState(controller?.state);
  const { setTabClicked } = useCurrentVideoStore();

  useEffect(() => controller?.subscribe(() => setState(controller.state)), [controller]);

  if (controller?.state.currentPages.length <= 1) {
    return <></>;
  }

  const handleScroll = () => {
    const videoGalleryElement = document.getElementById('globalVideoGallery');
    if (videoGalleryElement) {
      setTimeout(() => {
        videoGalleryElement.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <nav className={pagerClasses?.pagerWrapper}>
      <button
        className={classNames(
          pagerClasses?.navButton,
          pagerClasses?.previousButton,
          !state?.hasPreviousPage && pagerClasses?.disabledNavButton
        )}
        disabled={!state?.hasPreviousPage}
        onClick={() => {
          controller.previousPage();
          handleScroll();
          // ensure that the video tab change settinsg are reset when page is changed.
          setTabClicked(false);
        }}
        title="btn-previous"
      >
        <SvgIcon icon="arrow-left" size="md" />
      </button>
      {state?.currentPages.map((page) => (
        <button
          key={page}
          disabled={controller.isCurrentPage(page)}
          onClick={() => {
            controller.selectPage(page);
            handleScroll();
            // ensure that the video tab change settinsg are reset when page is changed.
            setTabClicked(false);
          }}
          className={twMerge(
            pagerClasses?.pageNumber,
            controller.isCurrentPage(page) && pagerClasses?.currentPage
          )}
          title="btn-page-number"
        >
          {page}
        </button>
      ))}
      <button
        className={classNames(
          pagerClasses?.navButton,
          pagerClasses?.nextButton,
          !state?.hasNextPage && pagerClasses?.disabledNavButton
        )}
        disabled={!state?.hasNextPage}
        onClick={() => {
          controller.nextPage();
          handleScroll();
          // ensure that the video tab change settinsg are reset when page is changed.
          setTabClicked(false);
        }}
        title="btn-next"
      >
        <SvgIcon icon="arrow-right" size="md" />
      </button>
    </nav>
  );
};
